import React from "react";
import FlatButton from "material-ui/FlatButton";
import Dialog from "material-ui/Dialog";
import { PropTypes } from "prop-types";
import { connectWithLifecycle } from "react-lifecycle-component";
import {
  deleteOrder,
  closeDeleteOrderDialog
} from "../../redux/modules/ordersDuck";
import { isDeleteOrderDialogVisible } from "../../redux/selectors";
import { push } from "react-router-redux";

const mapStateToProps = state => {
  return {
    deleteOrderDialogVisible: isDeleteOrderDialogVisible(state)
  };
};

const mapDispatchToProps = dispatch => ({
  handleDeleteOrder: orderId => {
    dispatch(deleteOrder(orderId));
    dispatch(push("/"));
  },
  handleCloseDialog: () => {
    dispatch(closeDeleteOrderDialog());
  }
});

export const DeleteOrderDialogPresentational = ({
  order,
  deleteOrderDialogVisible,
  handleDeleteOrder,
  handleCloseDialog
}) => {
  return (
    <Dialog
      title="Confirmación de borrado de pedido"
      actions={[
        <FlatButton
          label="Cancelar"
          primary={true}
          onClick={() => handleCloseDialog()}
        />,
        <FlatButton
          label="Borrar Pedido"
          primary={true}
          onClick={() => handleDeleteOrder(order.id)}
        />
      ]}
      modal={false}
      open={deleteOrderDialogVisible}
      onRequestClose={() => handleCloseDialog()}
    >
      ¿Está seguro que desea borrar este pedido a nombre de {order.customerName}?
    </Dialog>
  );
};

DeleteOrderDialogPresentational.propTypes = {
  order: PropTypes.object.isRequired,
  deleteOrderDialogVisible: PropTypes.bool.isRequired,
  handleDeleteOrder: PropTypes.func.isRequired,
  handleCloseDialog: PropTypes.func.isRequired
};

const DeleteOrderDialog = connectWithLifecycle(
  mapStateToProps,
  mapDispatchToProps
)(DeleteOrderDialogPresentational);

DeleteOrderDialog.propTypes = {
  order: PropTypes.object.isRequired
};

export default DeleteOrderDialog;



// WEBPACK FOOTER //
// ./src/components/container/DeleteOrderDialog.js